export default {
    "Login": "Вхід",
    "E-mail": "Електронна пошта",
    "Password": "Пароль",
    "Enter your email": "Введіть Вашу поштову адресу",
    "Enter your firstname": "Введіть Вашe Ім'я",
    "Enter your password": "Введіть Ваш пароль",
    "Show": "Показати",
    "Hide": "Заховати",
    "Forgot password?": "Забули пароль?",
    "login": "вхід",
    "SIGN IN WITH GOOGLE": "Ввійти через google",
    "Sign up": "Зареєструватися",
    "Add your current email": "Добавте Вашу поточну поштову адресу",
    "cancel": "відміна",
    "ok": "добре",
    "Done": "Виконано",
    "To change your password please check your email": "Перевірте Вашу поштову адрасу, щоб змінити пароль",
    "back to login": "Повернутись на сторінку входу",
    "Email can not be empty": "Електронна пошта є обов'язковою",
    "This mail is already used": "Електронна пошта уже використовується",
    "First Name can not be empty": "Ім'я є обов'язковим",
    "Last Name can not be empty": "Прізвище є обов'язковим",
    "Invalid email": "Неправильна електронна пошта",
    "Password can not be empty": "Пароль є обов'язковим",
    "Password confirmation can not be empty": "Підтвердження пароля є обов'язковим",
    "The password confirmation does not match": "Паролі не співпадають",
    "The password field may not be lesser than {amount} characters": "Мінімальна кількість символів - {amount}",
    "The first name field may not be greater than {amount} characters": "Максимальна кількість символів - {amount}",
    "Registration": "Реєстрація",
    "First Name": "Ім'я",
    "Last Name": "Прізвище",
    "Enter your lastname": "Введіть Ваше прізвище",
    "Enter confirm password": "Підтвердіть пароль",
    "CONFIRM PASSWORD": "Підтвердження пароля",
    "REGISTER": "Зареєструватись",
    "Back to": "Повернутись на",
    "login page": "сторінку входу",
    "go to login": "Повернутись на сторінку входу",
    "Check you're email to confirm registration": "Перевірте свою електронну пошту, щоб підтвердити реєстрацію",
    
    "Do you need new glasses? Please, click on the button!": "Чи потрібні Вам окуляри? Натисніть на кнопку, щоб замовити!",
    "BUY PURE PURR": "ЗАМОВИТИ PURE PURR",
    "delete": "Видалити",
    "You have no cards": "У Вас немає карток",
    "Requested VR was sent to your email. Please, open your email and activate these glasses on your website.": "VR був надісланий на Вашу електронну пошту. Відкрийте електронну пошту та активуйте окуляри на своєму веб-сайті.",
    "Do you have promocodes?": "У Вас є промокоди?",
    'What payment method do you prefer?' : 'Оберіть платіжний метод',
    "yes": "так",
    "no": "ні",
    "Please add your promocode here and move forward": "Будь ласка введіть Ваш промокод тут і продовжіть далі",
    "Enter Your Promocode": "Введіть Ваш промокод",
    "Your VR is delivered!": "Ваші VR окуляри доставлено!",
    "Your devices": "Ваші пристрої",
    "server time:": "час на сервері:",
    "subscription": "підписка",
    "cancel subscription": "відмінити підписку",
    "pay with card": "розрахуватись карткою",
    "buy videos": "придбати відео",
    "Add device": "Додати пристрій",
    "ACTIVATE": "АКТИВУВАТИ",
    "i cant understand why": "Я не можу зрозуміти чому",
    "EDIT YOUR NAME": "РЕДАГУВАТИ ІМ'Я",
    "Enter your new name": "Введіть Ваше нове Ім'я",
    "Enter your new lastname": "Введіть Ваше нове прізвище",
    "save": "зберегти",
    "Don’t have an account?": "У вас є обліковий запис?",
    "Don’t you remember your current password?": "Не можете згадати ваш пароль?",
    "New password": "Новий пароль",
    "New email": "Новa eлектронна пошта",
    "EMAIL": "Електронна пошта",
    "Current password": "Поточний пароль",
    "Reset your password via email": "Скиньте пароль через електронну пошту",
    "Set password": "Встановити пароль",
    "Set your password": "Встановіть Ваш пароль",
    "We send you an email with instructions on how to reset your password.": "Ми надішлемо вам електронний лист з інструкціями про те, як скинути пароль.",
    "Confirm Your Password": "Підтвердіть Ваш пароль",
    "Email input not valid or empty": "Поле електронної пошти недійсну або порожнє",
    "First or Last Name cannot be empty": "Ім'я або Прізвище не може бути порожнім",
    "Successfully changed": "Успішно змінено",
    "Number": "Номер",
    "Status": "Статус",
    "Number of views": "Кількість сеансів",
    "Expiration date": "Дата закінчення передплати",
    "Invoice will be sent to your email. It will be delivered within 1 hour. Please, proceed with payment using your email": "Запит буде надіслано на вашу електронну пошту. Його буде доставлено протягом 1 години. Будь ласка, продовжуйте оплату за допомогою електронної пошти",
    "You have subscription. Are you sure that you want to cancel subscription?": "У вас є підписка. Дійсно скасувати підписку?",
    "Invoice was already sent and was not paid yet. Do you want to cancel?": "Запит вже надісланий і ще не сплачений. Скасувати?",
    "Please, open your app and switch on Wi-Fi on VR glasses to update the views counts. Once it is updated, you will be able to buy views here, clicking on the same button": "Будь ласка, відкрийте додоток та увімкніть Wi-Fi на окулярах VR, щоб оновити кількість переглядів. Після оновлення ви зможете придбати тут перегляди, натиснувши на ту ж кнопку",
    "You canceled subscription": "Ви відмінили підписку",

    "This email is already in use, Please, take another email": "Ця електронна пошта вже використовується, будь ласка скористайтесь іншою електронною поштою.",
    "json hasnt needed fields": "json hasnt needed fields",
    "password has less then 8 numbers": "Пароль має менше 8 символів",
    "bad request to google api": "bad request to google api",
    "bad google token while google auth": "bad google token while google auth",
    "authentification hasnt user": "Аутентифіцікація не має користувача",
    "users email cant be found in db": "Електронну пошту користувача не вдалося знайти в базі.",
    "user logged in only via google": "користувач авторизований лише через google",
    "user already has password": "користувач вже має пароль ",
    "This serial number of VR is not available for users": "Цей серійний номер VR є недоступним для користувачів ",
    "This serial number of VR is already in use! Please, check the number": "Цей серійний номер VR вже використовується! Будь ласка перевірте номер",
    "This serial number of VR doesn't exist in our system.Please, check the serial number": "Цей серійний номер VR не існує в нашій системі. Будь ласка перевірте номер",
    "link cant be found in db": "посилання неможливо знайти в базі",
    "link expired": "link expired",
    "This user doesn't exist. Please, check your credentials": "Цей користувач не існує. Будь ласка перевірте ваші дані",
    "cant decode link": "Неможливо декодувати посилання",
    "not valid email": "некоректна електронна пошта",
    "error while sending email": "помилка при відправці електронної пошти",
    "cant process string to json": "cant process string to json",
    "cant check link singnature": "cant check link singnature",
    "This promocode is not valid": "Цей промокод недійсний",
    "There are no available glasses": "Немає доступних окулярів",
    "Your current pasword is wrong, please try one more time": "Ваш поточний пороль неправильний, будь ласка спробуйте ще раз.",

    "In Stock": "В наявності",
    "Awaiting for Activation": "Очікує на активацію",
    "Activated": "Активований",

    "View": "Перегляди",
    "Views": "Переглядів"
};